<template lang="pug">
#home-for-families-service.mb-0
  // facility information
  .row.facility-base-info(v-if="_showCareimage")
    .home-box.col-sm-6.col-md-4.col-xl-2
      HomeCountBox(title="登録済み利用者数" :count="residentCount" :isBusy="isBusyResidentCount" unit="人")
    .home-box.col-sm-6.col-md-4.col-xl-2
      HomeCountBox(title="家族ユーザー数" :count="userCount" :isBusy="isBusyUserCount" unit="人")
    .home-box.col-sm-6.col-md-4.col-xl-2
      HomeCountBox(title="今月の家族使用" :count="useCount" :isBusy="isBusyUseCount" unit="回")
    .home-box.col-sm-6.col-md-4.col-xl-2
      HomeFractionCountBox(
        v-show="yesterdayCareimage.molecule != -1"
        title="昨日の介護記録"
        :molecule="yesterdayCareimage.molecule"
        :denominator="yesterdayCareimage.denominator"
        :isBusy="isBusyYesterdayCareimage"
        unit="人分"
      )
    .home-box.col-sm-6.col-md-4.col-xl-2
      HomeFractionCountBox(
        v-show="todayCareimage.molecule != -1"
        title="今日の介護記録"
        :molecule="todayCareimage.molecule"
        :denominator="todayCareimage.denominator"
        :isBusy="isBusyTodayCareimage"
        unit="人分"
      )
    .home-box.col-sm-6.col-md-4.col-xl-2
      HomeDateBox(title="最新記録公開日"
        v-show="careimageLatestPublicDate.year != -1"
        :year="careimageLatestPublicDate.year"
        :month="careimageLatestPublicDate.month"
        :date="careimageLatestPublicDate.date"
        :isBusy="isBusyCareimageLatestPublicDate"
        :yearSmall="true"
      )

  .row.facility-base-info(v-if="!_showCareimage")
    .home-box.col-sm-6.col-md-4.col-xl-4
      HomeCountBox(title="登録済み利用者数" :count="residentCount" :isBusy="isBusyResidentCount" unit="人")
    .home-box.col-sm-6.col-md-4.col-xl-4
      HomeCountBox(title="家族ユーザー数" :count="userCount" :isBusy="isBusyUserCount" unit="人")
    .home-box.col-sm-6.col-md-4.col-xl-4
      HomeCountBox(title="今月の家族使用" :count="useCount" :isBusy="isBusyUseCount" unit="回")
  
  // calendar on week
  .row.calendar
    .col-12
      .box.box-margin
        .title.d-flex.justify-content-start.align-items-center
          .d-flex.justify-content-start.align-items-center
            span.mr-2 一週間の予定
            span.open-all(v-show="showAllCalendar == false" @click="toggleShowAllCalendar") 全て表示
            span.close-all(v-show="showAllCalendar == true" @click="toggleShowAllCalendar") 閉じる
          .d-flex.justify-content-end.align-items-center.flex-fill
            .options.d-flex.align-items-center.mr-2
              span.table-option-text.mr-2 利用者グループ:
              .filter
                b-form-select(id="filter-input" v-model="filter" :options="filterOptions" size="sm")
            button.btn.goto-reports-btn(v-if="_enableReportsByPlan && _enableReportsByPermittedFunction" @click="gotoReport" type="button") 月表示で見る
            a.btn.goto-reports-btn.disable#goto-reports(v-if="!_enableReportsByPlan" type="button") 月表示で見る
            b-popover(v-if="!_enableReportsByPlan" target="goto-reports" triggers="hover")
              span ライトプラン以上で使用可能

        .box-body(:style="_calendarStyle")
          CalendarOfWeek(v-model="currentDate" :events="_filteredEvents" :showChangeWeekBtn="false" :small="true" :isBusy="calendarIsBusy" cellHeight="135px")

  // function usage graph
  .row.graphs
    .ratio-graph.col-md-12.col-lg-5
      .box.box-margin
        .box-header.title 家族の使用回数（機能別、最近3ヶ月）
        .box-body
          DoughnutChart(:chart-data="functionUseRateGraph" :height="functionUseRateGraphHeight")
          Loading(ref="ratioGraphLoading")

    .bar-graph.col-md-12.col-lg-7
      .box.box-margin
        .box-header.title 家族の使用回数（時間帯）
        .box-body
          .row
            .col-12.d-flex.flex-row
              .d-flex.justify-content-start
                .align-self-center.date {{ _functionUseHourGraphDate }}
              .d-flex.flex-row.justify-content-end.align-items-end.flex-fill
                button.btn.change-date-btn.mr-2(@click="onPrevUseHourGraph()") ＜ 前の日
                button.btn.change-date-btn.mr-2(@click="onCurrentUseHourGraph()") 今日
                button.btn.change-date-btn(v-if="canOnNextUseHourGraph()" @click="onNextUseHourGraph()") 次の日 ＞
                button.btn.change-date-btn.disable(v-else disabled) 次の日 ＞
          .row
            .col-12
              BarChart(:chart-data="functionUseHourGraph" :height="functionUseHourGraphHeight")
          Loading(ref="barGraphLoading")
</template>

<script lang="ts">
import { Component, Inject, Watch, Vue } from "vue-property-decorator";
import moment, { Moment } from "moment";
import { userStore, itemListFilterStore } from "@/store/store";
import { ChartData } from "chart.js";

import CalendarEventsService, { CalendarEventGetModel, CalendarFilterType } from "@/commons/services/CalendarEvents";
import ResidentsService, { ResidentGetModel } from "@/commons/services/Residents";
import CareimagesService from "@/commons/services/Careimages";
import CareimageModel from "@/commons/models/Careimage";
import LatestCareimageDateService from "@/commons/services/LatestCareimageDate";
import UseMessageCountsService, { FunctionCountGetModel } from "@/commons/services/UseMessageCounts";
import EventsService, { EventGetModel, EventHoldType, EventTargetType } from "@/commons/services/Events";
import ReservationsService, { ReservationsGetModel, ReservationType } from "@/commons/services/Reservations";
import OutingsService, { OutingGetModel, OutingType } from "@/commons/services/Outings";
import InspectionReservationsService, { InspectionReservationsGetModel } from "@/commons/services/InspectionReservations";
import OtherOfficeOnlineMeetingsService, { OtherOfficeOnlineMeetingGetModel } from "@/commons/services/OtherOfficeOnlineMeetings";
import ResidentGroupsService, { ResidentGroupsGetModel } from "@/commons/services/ResidentGroups";
import SystemError from "@/commons/models/SystemError";
import { PermittedFunctions } from "@/commons/services/Facilities";

import HomeCountBox from "@/pc/basics/HomeCountBox.vue";
import HomeFractionCountBox from "@/pc/basics/HomeFractionCountBox.vue";
import HomeDateBox from "@/pc/basics/HomeDateBox.vue";
import DoughnutChart from "@/pc/basics/DoughnutChart.vue";
import BarChart from "@/pc/basics/BarChart.vue";
import CalendarOfWeek from "@/pc/components/CalendarOfWeek.vue";
import { CalendarEvent, CalendarHitomeQEventType } from "@/pc/components/CalendarOfMonth.vue";
import Loading from "@/pc/basics/Loading.vue";
import { PlanType } from "@/commons/services/Plans";
import { PcUrl } from "@/commons/constants/PcUrl";

/**
 * ホーム画面コンポーネント
 *
 */
@Component({
  components: {
    HomeCountBox,
    HomeFractionCountBox,
    HomeDateBox,
    DoughnutChart,
    BarChart,
    CalendarOfWeek,
    Loading
  }
})
export default class HomeForFamiliesService extends Vue {
  /** カレンダーイベントサービス */
  @Inject("CalendarEventsService") calendarEventsService!: CalendarEventsService;
  /** 利用者サービス */
  @Inject("ResidentsService") residentsService!: ResidentsService;
  /** 介護記録サービス */
  @Inject("CareimagesService") careimagesService!: CareimagesService;
  /** 介護記録最終公開日サービス */
  @Inject("LatestCareimageDateService") latestCareimageDateService!: LatestCareimageDateService;
  /** メッセージ利用数サービス */
  @Inject("UseMessageCountsService") useMessageCountsService!: UseMessageCountsService;
  /** イベントサービス */
  @Inject("EventsService") eventsService!: EventsService;
  /** 面会予約サービス(複数) */
  @Inject("ReservationsService") reservationsService!: ReservationsService;
  /** 外出外泊サービス */
  @Inject("OutingsService") outingsService!: OutingsService;
  /** 施設見学サービス */
  @Inject("InspectionReservationsService") inspectionReservationsService!: InspectionReservationsService;
  /** 他事業所連携オンライン会議サービス */
  @Inject("OtherOfficeOnlineMeetingsService") meetingsService!: OtherOfficeOnlineMeetingsService;
  /** 利用者グループサービス */
  @Inject("ResidentGroupsService") residentGroupsService!: ResidentGroupsService;

  readonly eventColors: CalendarFunctionEvent = {
    original: {
      color: "#ffffff",
      bgColor: "#646464"
    },
    resident: {
      color: "#383838",
      bgColor: "#4ad9e9"
    },
    event: {
      color: "#383838",
      bgColor: "#a0e393"
    },
    reservation: {
      color: "#383838",
      bgColor: "#edc575"
    },
    inspectionReservation: {
      color: "#383838",
      bgColor: "#c9f4f9",
      borderColor: "#19bacc"
    },
    onlineMeeting: {
      color: "#ffffff",
      bgColor: "#646464"
    },
    outing: {
      color: "#383838",
      bgColor: "#feecca"
    }
  };

  /** 利用者数 */
  residentCount: number = 0;
  /** 利用者数読込み中 */
  isBusyResidentCount: boolean = true;
  /** ユーザー数 */
  userCount: number = 0;
  /** ユーザー数読込み中 */
  isBusyUserCount: boolean = true;
  /** 使用回数 */
  useCount: number = 0;
  /** 使用回数読込み中 */
  isBusyUseCount: boolean = true;
  /** 昨日の介護記録登録数 */
  yesterdayCareimage: any = {
    molecule: 0,
    denominator: 0
  };
  /** 昨日の介護記録登録数読込み中 */
  isBusyYesterdayCareimage: boolean = true;
  /** 今日の介護記録登録数 */
  todayCareimage: any = {
    molecule: 0,
    denominator: 0
  };
  /** 今日の介護記録登録数読込み中 */
  isBusyTodayCareimage: boolean = true;
  /** 介護記録の最新公開日 */
  careimageLatestPublicDate: any = {
    year: "",
    month: "",
    date: ""
  };
  /** 介護記録の最新公開日読込み中 */
  isBusyCareimageLatestPublicDate: boolean = true;

  /** 機能利用数：割合のグラフ */
  functionUseRateGraph: ChartData = {};
  functionUseRateGraphHeight: number = 248;

  /** 機能利用数：時間帯のグラフ */
  functionUseHourGraphDate: Date = new Date();
  functionUseHourGraph: ChartData = {};
  functionUseHourGraphHeight: number = 216;

  /** 現在日 */
  currentDate: Moment = moment();
  /** カレンダーイベント */
  events: Array<CalendarEvent> = [];
  /** カレンダー読込み中 */
  calendarIsBusy: boolean = true;
  /** カレンダーを全て表示するか否か */
  showAllCalendar: boolean = false;

  /** フィルタリング条件 */
  filter: string = "";
  /** フィルター選択項目 */
  filterOptions: Array<{ value: string; text: string }> = [];

  /**
   * ### 現在日の変更監視
   *
   * - イベントを作り直す
   */
  @Watch("currentDate")
  public async changeCurrentDate(newValue: Moment): Promise<void> {
    console.debug(`changeCurrentDate() year:${newValue.get("year")} month:${newValue.get("month") + 1}`);

    // 時間帯分析の設定は画面表示時にPromise.all()して使うため、例外が発生しても例外をthrowしない
    // 代わりに戻り値でエラーを返すので、戻り値がエラーであれば例外を代わりに投げて共通エラーハンドラーに渡す
    const error: void | SystemError = await this.setCalendarEvents();
    if (error) {
      throw error;
    }

    return;
  }

  @Watch("filter")
  public changeFilter(): void {
    if (this.$options.name) {
      itemListFilterStore.setFilter({ url: this.$options.name, filter: this.filter });
    }
  }

  /** 画面表示用の機能利用数：時間帯の日付 */
  get _functionUseHourGraphDate(): string {
    return this.$dateUtil.convertDateToString(this.functionUseHourGraphDate, "yyyy年mm月dd日", false);
  }

  /** 介護記録の機能使用可否 */
  get _showCareimage(): boolean {
    return userStore.facility.permittedFunctions.careimage;
  }

  /** 面会予約の機能使用可否 */
  get _showReservation(): boolean {
    const permitted: PermittedFunctions = userStore.facility.permittedFunctions;
    if (permitted.reservation == false && permitted.onlineReservation == false) {
      return false;
    } else {
      return true;
    }
  }

  /** ### プランがライト以上かを返す */
  get _isOverLightPlan(): boolean {
    const planType: PlanType = userStore.facility.planType;
    if (PlanType.LIGHT <= planType) {
      return true;
    } else {
      return false;
    }
  }

  get _useWaiterService(): boolean {
    return userStore.facility.useWaiterService && userStore.loginUser.permissions.functions.useWaiterService;
  }

  get _useOtherOfficeService(): boolean {
    return userStore.facility.useOtherOfficeConnectionService && userStore.loginUser.permissions.functions.useOtherOfficeConnectionService;
  }

  get _currentDate(): string {
    if (this.currentDate) {
      const currentDate: Date = this.currentDate.toDate();
      return this.$dateUtil.convertDateToString(currentDate, "yyyy年mm月", false);
    } else {
      return "";
    }
  }

  get _filteredEvents(): Array<CalendarEvent> {
    const filterdEvents: Array<CalendarEvent> = this.events.concat().filter((event: CalendarEvent) => {
      switch (event.hitomeQEvent.type) {
        case CalendarHitomeQEventType.MEMO: {
          const facilityEvent: CalendarEventGetModel = event.hitomeQEvent.source as CalendarEventGetModel;
          if (facilityEvent.filterType == CalendarFilterType.FACILITY) {
            return true;
          } else if (facilityEvent.filterType == CalendarFilterType.RESIDENT_GROUP) {
            if (Number(this.filter) != 0 && facilityEvent.residentGroups.indexOf(Number(this.filter)) == -1) {
              return false;
            } else {
              return true;
            }
          }
          return false;
        }
        case CalendarHitomeQEventType.EVENT_LOCAL_ONLY:
        case CalendarHitomeQEventType.EVENT_ONLINE_ONLY:
        case CalendarHitomeQEventType.EVENT_LOCAL_AND_ONLINE: {
          const facilityEvent: EventGetModel = event.hitomeQEvent.source as EventGetModel;
          if (Number(this.filter) != 0 && facilityEvent.targetType == EventTargetType.RESIDENT_GROUP) {
            let existGroup: boolean = false;
            for (const groupId of facilityEvent.targets) {
              if (groupId == Number(this.filter)) {
                existGroup = true;
                continue;
              }
            }
            return existGroup;
          }
          return true;
        }
        case CalendarHitomeQEventType.RESIDENT_IN_DATE:
        case CalendarHitomeQEventType.RESIDENT_OUT_DATE: {
          const residet: ResidentGetModel = event.hitomeQEvent.source as ResidentGetModel;
          if (Number(this.filter) != 0 && residet.groupId != Number(this.filter)) {
            return false;
          } else {
            return true;
          }
        }
        case CalendarHitomeQEventType.RESERVATION_VISIT:
        case CalendarHitomeQEventType.RESERVATION_ONLINE: {
          const reservation: ReservationsGetModel = event.hitomeQEvent.source as ReservationsGetModel;
          if (Number(this.filter) != 0 && reservation.groupId != Number(this.filter)) {
            return false;
          } else {
            return true;
          }
        }
        case CalendarHitomeQEventType.INSPECTION_RESERVATION: {
          return true;
        }
        case CalendarHitomeQEventType.ONLINE_MEETING: {
          return true;
        }
        case CalendarHitomeQEventType.OUTING_GOING_OUT:
        case CalendarHitomeQEventType.OUTING_STAYING_OUT: {
          const outing: OutingGetModel = event.hitomeQEvent.source as OutingGetModel;
          if (Number(this.filter) != 0 && outing.targetResidentInfo.groupId != Number(this.filter)) {
            return false;
          } else {
            return true;
          }
        }
        default: {
          return false;
        }
      }
    });

    return filterdEvents;
  }

  /** vueのエラーが出るので定義だけ作成している */
  set _filteredEvents(newValue: Array<CalendarEvent>) {
    return;
  }

  get _calendarStyle(): string {
    return this.showAllCalendar == true ? "" : "height:185px;";
  }

  public toggleShowAllCalendar() {
    this.showAllCalendar = !this.showAllCalendar;
  }

  /**
   * vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    await this.createView();
    return;
  }

  public async createView(): Promise<void> {
    // カレンダー取得処理を先に実施して表示速度改善を目指す
    await this.setCalendarEvents();

    const results: Array<any> = await Promise.all([
      this.setFilterOptions(),
      this.setResidents(),
      this.setUseCount(),
      this.setYesterdayCareimageCount(),
      this.setTodayCareimageCount(),
      this.setCareimageLatestPublicDate(),
      this.setFunctionUseRateGraph(),
      this.setFunctionUseHourGraph(this.functionUseHourGraphDate)
    ]);

    // 非同期処理中に例外が発生していればresultの中にSystemerrorが格納されているのでチェックする
    for (const result of results) {
      if (result instanceof SystemError) {
        console.error("error:", result);
      }
    }

    return;
  }

  /**
   * 利用者グループを取得してフィルターを作成する
   */
  public async setFilterOptions(): Promise<void | SystemError> {
    try {
      const groups: Array<ResidentGroupsGetModel> = await this.getResidentGroups();
      this.filterOptions = this.createFilterOptions(groups);
      this.restoreFilterSetting();
    } catch (error) {
      return error as SystemError;
    }
  }

  /**
   * ### 全ての利用者グループを取得する
   */
  public async getResidentGroups(): Promise<Array<ResidentGroupsGetModel>> {
    const response: Array<ResidentGroupsGetModel> = await this.residentGroupsService.gets(userStore);
    return response;
  }

  /**
   * ### 利用者グループフィルター用選択項目
   */
  public createFilterOptions(residentGroups: Array<ResidentGroupsGetModel>): Array<{ value: string; text: string }> {
    const filterOptions: Array<{ value: string; text: string }> = [];

    filterOptions.push({
      value: "",
      text: "全て"
    });

    const allowedGroupsMap: Map<number, number> = new Map<number, number>();
    for (const allowedGroup of userStore.loginUser.permissions.residentGroups) {
      allowedGroupsMap.set(allowedGroup, allowedGroup);
    }
    for (const group of residentGroups) {
      if (allowedGroupsMap.has(group.id)) {
        filterOptions.push({
          value: `${group.id}`,
          text: group.name
        });
      }
    }

    return filterOptions;
  }

  /** フィルタ情報がstoreに存在する場合は復元する */
  private restoreFilterSetting(): void {
    if (this.$options.name && itemListFilterStore.filterMap[this.$options.name] != undefined) {
      this.filter = itemListFilterStore.filterMap[this.$options.name];
    }
    return;
  }

  /**
   * 利用者に関連する情報を取得し、画面表示用プロパティに格納する
   */
  public async setResidents(): Promise<void | SystemError> {
    try {
      // 利用者数、家族ユーザー数を取得する
      const residents: Array<ResidentGetModel> = await this.getResidents();
      this.residentCount = residents.length;
      this.isBusyResidentCount = false;

      // 使用者にひもづく家族を取得し、家族ユーザー数をカウントする
      let userCount: number = 0;
      for (let resident of residents) {
        if (resident.familyCount) {
          userCount += resident.familyCount;
        }
      }
      this.userCount = userCount;
      this.isBusyUserCount = false;

      // 昨日の介護記録登録数、今日の介護記録登録数で使用する分母は利用者数なのでここで格納する
      this.yesterdayCareimage.denominator = residents.length;
      this.todayCareimage.denominator = residents.length;
    } catch (error) {
      // Promise.all()で並列に実行されるので例外を投げなおすのではなく例外を戻り値として返す
      return error as SystemError;
    }

    return;
  }

  /**
   * 利用者を取得する
   */
  public async getResidents(): Promise<Array<ResidentGetModel>> {
    const params: any = {
      masking: "none"
    };
    let response: Array<ResidentGetModel> = [];

    try {
      response = await this.residentsService.gets(userStore, params);
    } catch (error) {
      const systemerror: SystemError = error as SystemError;
      // 413エラーの場合、全件取得した結果がペイロード制限に引っかかったことになるので、index指定で段階的に取得する
      if (systemerror.statusCode == 413) {
        const pagePerCount: number = 50;
        const count: number = await this.residentsService.getCount(userStore);
        const loopEnd: number = Math.ceil(count / pagePerCount);

        for (let i = 0; i < loopEnd; i++) {
          const params: { startIndex: number; endIndex: number; masking: string } = {
            startIndex: i * pagePerCount,
            endIndex: i * pagePerCount + pagePerCount,
            masking: "none"
          };
          response = response.concat(await this.residentsService.gets(userStore, params));
        }
      }
    }
    return response;
  }

  /**
   * 使用回数を取得し、画面表示用プロパティに格納する
   *
   * 使用回数＝家族がLINEbotへ送ったメッセージの件数であり、LINEメッセージ全件ではない
   * 期間は現在月の1日～今日まで
   */
  public async setUseCount(): Promise<void | SystemError> {
    try {
      const response: number = await this.useMessageCountsService.getMonthlyCounts(userStore);

      this.useCount = response;
      this.isBusyUseCount = false;
    } catch (error) {
      // Promise.all()で並列に実行されるので例外を投げなおすのではなく例外を戻り値として返す
      return error as SystemError;
    }

    return;
  }

  /**
   * 昨日登録された介護記録を取得し、画面表示用プロパティに格納する
   */
  public async setYesterdayCareimageCount(): Promise<void | SystemError> {
    // 介護記録機能が使用不可の場合は即returnする
    if (!userStore.facility.permittedFunctions.careimage) {
      return;
    }

    try {
      // 昨日の介護記録登録数
      // 分子は昨日登録された介護記録数、分母は利用者数を使用する
      let date: Date = new Date();
      date.setDate(date.getDate() - 1);
      const yesterday: number = this.$dateUtil.convertDateToNumber(date, "yyyymmdd000000000");
      const yesterdayCareimages: Array<CareimageModel> = await this.getCareimage(yesterday, yesterday);

      this.yesterdayCareimage.molecule = yesterdayCareimages.length;
      this.isBusyYesterdayCareimage = false;
    } catch (error) {
      // 機能使用不可でステータスコード405が返却された場合はエラーとして扱わない
      const systemError: SystemError = error as SystemError;
      if (systemError.statusCode == 405) {
        this.yesterdayCareimage.molecule = -1;
        this.isBusyYesterdayCareimage = false;
        return undefined;
      } else {
        // Promise.all()で並列に実行されるので例外を投げなおすのではなく例外を戻り値として返す
        return error as SystemError;
      }
    }

    return;
  }

  /**
   * 今日登録された介護記録を取得し、画面表示用プロパティに格納する
   */
  public async setTodayCareimageCount(): Promise<void | SystemError> {
    // 介護記録機能が使用不可の場合は即returnする
    if (!userStore.facility.permittedFunctions.careimage) {
      return;
    }

    try {
      // 今日の介護記録登録数
      // 分子は昨日登録された介護記録数、分母は利用者数を使用する
      const today: number = this.$dateUtil.convertDateToNumber(new Date(), "yyyymmdd000000000");
      const todayCareimages: Array<CareimageModel> = await this.getCareimage(today, today);

      this.todayCareimage.molecule = todayCareimages.length;
      this.isBusyTodayCareimage = false;
    } catch (error) {
      // 機能使用不可でステータスコード405が返却された場合はエラーとして扱わない
      const systemError: SystemError = error as SystemError;
      if (systemError.statusCode == 405) {
        this.todayCareimage.molecule = -1;
        this.isBusyTodayCareimage = false;
        return undefined;
      } else {
        // Promise.all()で並列に実行されるので例外を投げなおすのではなく例外を戻り値として返す
        return error as SystemError;
      }
    }

    return;
  }

  /**
   * 指定期間内の介護記録を取得する
   */
  public async getCareimage(start: number, end: number): Promise<Array<CareimageModel>> {
    const params: any = {
      start: start,
      end: end
    };

    const response: Array<CareimageModel> = await this.careimagesService.get(userStore, params);

    return response;
  }

  /**
   * 介護記録の最新公開日を取得し、画面表示用プロパティに格納する
   */
  public async setCareimageLatestPublicDate(): Promise<void | SystemError> {
    // 介護記録機能が使用不可の場合は即returnする
    if (!userStore.facility.permittedFunctions.careimage) {
      return;
    }

    try {
      // 介護記録の最新公開日を取得する
      const careimageLatestPublicDate: number | undefined = await this.getCareimageLatestPublicDate();
      if (careimageLatestPublicDate) {
        this.careimageLatestPublicDate.year = this.$dateUtil.convertNumberToString(careimageLatestPublicDate, "yyyy");
        this.careimageLatestPublicDate.month = this.$dateUtil.convertNumberToString(careimageLatestPublicDate, "mm", false);
        this.careimageLatestPublicDate.date = this.$dateUtil.convertNumberToString(careimageLatestPublicDate, "dd", false);
      }
      this.isBusyCareimageLatestPublicDate = false;
    } catch (error) {
      // 機能使用不可でステータスコード405が返却された場合はエラーとして扱わない
      const systemError: SystemError = error as SystemError;
      if (systemError.statusCode == 405) {
        this.careimageLatestPublicDate.year = -1;
        this.careimageLatestPublicDate.month = -1;
        this.careimageLatestPublicDate.date = -1;
        this.isBusyCareimageLatestPublicDate = false;
        return undefined;
      } else {
        // Promise.all()で並列に実行されるので例外を投げなおすのではなく例外を戻り値として返す
        return error as SystemError;
      }
    }

    return;
  }

  /**
   * 介護記録の最新公開日を取得する
   */
  public async getCareimageLatestPublicDate(): Promise<number | undefined> {
    const response: number | undefined = await this.latestCareimageDateService.get(userStore);

    return response;
  }

  /**
   * 機能使用数：割合グラフに表示する内容を作成する
   */
  public async setFunctionUseRateGraph(): Promise<void | SystemError> {
    const ratioGraphLoading: any = this.$refs.ratioGraphLoading;
    if (ratioGraphLoading) {
      ratioGraphLoading.show();
    }

    try {
      // 機能使用数のグラフ表示情報を作成する
      const startDate: Date = new Date();
      startDate.setMonth(startDate.getMonth() - 3);
      const start: number = this.$dateUtil.convertDateToNumber(startDate, "yyyymmdd000000000");
      const endDate: Date = new Date();
      endDate.setDate(endDate.getDate() + 1);
      const end: number = this.$dateUtil.convertDateToNumber(endDate, "yyyymmdd000000000");
      const response: Array<FunctionCountGetModel> = await this.useMessageCountsService.getFunctionCounts(userStore, { start, end });

      let counts: Array<number> = [];
      let labels: Array<string> = [];
      let backgroundColors: Array<string> = [];
      let borderWidths: Array<number> = [];

      for (const messageFunction of response) {
        counts.push(messageFunction.count);
        labels.push(messageFunction.name);
        backgroundColors.push(messageFunction.graphColor);
        borderWidths.push(0);
      }

      // DoughnutChart表示用のObjectを作る
      let chartjsData: ChartData = {
        labels: labels,
        datasets: [
          {
            label: "機能別使用割合",
            backgroundColor: backgroundColors,
            borderWidth: borderWidths,
            data: counts
          }
        ]
      };

      this.functionUseRateGraph = chartjsData;
    } catch (error) {
      // Promise.all()で並列に実行されるので例外を投げなおすのではなく例外を戻り値として返す
      return error as SystemError;
    } finally {
      // 画面遷移でコンポーネントが存在しないタイミングがあるため、存在可否をチェックしてからローディングを非表示にする
      if (ratioGraphLoading) {
        ratioGraphLoading.hide();
      }
    }

    return;
  }

  /**
   * 機能使用数：時間帯分析グラフに表示する内容を作成する
   * 分析対象日の0時から、次の日の0時までを分析対象期間とする
   *
   * @param day 分析対象日
   */
  public async setFunctionUseHourGraph(day: Date): Promise<void | SystemError> {
    const barGraphLoading: any = this.$refs.barGraphLoading;
    if (barGraphLoading) {
      barGraphLoading.show();
    }

    try {
      const start: number = this.$dateUtil.convertDateToNumber(day, "yyyymmdd000000000");
      // endはfromの日付から新しく作る
      let endDate: Date = new Date(day.getTime());
      endDate.setDate(endDate.getDate() + 1);
      const end: number = this.$dateUtil.convertDateToNumber(endDate, "yyyymmdd000000000");

      const queryParams: any = {
        start: start,
        end: end
      };
      const response: Array<number> = await this.useMessageCountsService.getEveryHourCounts(userStore, queryParams);

      // ラベル情報を作成する
      let labels = [];
      let data = [];
      for (let i = 0; i < 24; i++) {
        labels.push(i + "時");
        data.push(response[i]);
      }

      const chartjsData: ChartData = {
        labels: labels,
        datasets: [
          {
            label: "家族の使用回数",
            backgroundColor: "rgba(0, 140, 160, 1)",
            data: data
          }
        ]
      };

      this.functionUseHourGraph = chartjsData;
    } catch (error) {
      // Promise.all()で並列に実行されるので例外を投げなおすのではなく例外を戻り値として返す
      return error as SystemError;
    } finally {
      // 画面遷移でコンポーネントが存在しないタイミングがあるため、存在可否をチェックしてからローディングを非表示にする
      if (barGraphLoading) {
        barGraphLoading.hide();
      }
    }

    return;
  }

  /**
   * 機能使用数：時間帯分析グラフの「次の日」ボタン押下可能かを返す
   * 押下したら未来日になってしまう場合は押下不可
   */
  public canOnNextUseHourGraph(): boolean {
    const todayTime: number = new Date().getTime();
    const nextGraphDate: Date = new Date(this.functionUseHourGraphDate.getTime());
    nextGraphDate.setDate(nextGraphDate.getDate() + 1);
    const nextCurrentTime: number = nextGraphDate.getTime();

    if (todayTime <= nextCurrentTime) {
      return false;
    }

    return true;
  }

  /**
   * 機能使用数：時間帯分析グラフの「前の日」ボタン押下イベント
   * グラフの表示期間を1日前にする
   */
  public async onPrevUseHourGraph(): Promise<void> {
    this.functionUseHourGraphDate.setDate(this.functionUseHourGraphDate.getDate() - 1);
    await this.updateFunctionUseHourGraph();
    return;
  }

  /**
   * 機能使用数：時間帯分析グラフの「今日」ボタン押下イベント
   * グラフの表示期間を今日にする
   */
  public async onCurrentUseHourGraph(): Promise<void> {
    this.functionUseHourGraphDate = new Date();
    await this.updateFunctionUseHourGraph();
    return;
  }

  /**
   * 機能使用数：時間帯分析グラフの「次の日」ボタン押下イベント
   * グラフの表示期間を1日後にする
   */
  public async onNextUseHourGraph(): Promise<void> {
    this.functionUseHourGraphDate.setDate(this.functionUseHourGraphDate.getDate() + 1);
    await this.updateFunctionUseHourGraph();
    return;
  }

  /**
   * 機能使用数：時間帯分析グラフを更新する
   */
  public async updateFunctionUseHourGraph(): Promise<void> {
    // グラフの現在日を更新して、グラフを再描画させる
    // functionUseHourGraphDateにnew Date()したものを格納しなおしているのは、Date型のプロパティにsetDate()
    // してもVueが更新を検知できないため、Dateオブジェクトを作り直すことで変更を検知させている
    this.functionUseHourGraphDate = new Date(this.functionUseHourGraphDate.getTime());

    // 時間帯分析の設定は画面表示時にPromise.all()して使うため、例外が発生しても例外をthrowしない
    // 代わりに戻り値でエラーを返すので、戻り値がエラーであれば例外を代わりに投げて共通エラーハンドラーに渡す
    const error: void | SystemError = await this.setFunctionUseHourGraph(this.functionUseHourGraphDate);
    if (error) {
      throw error;
    }

    return;
  }

  /**
   * ### カレンダーに関連する情報を取得し、画面表示用プロパティに格納する
   *
   * - 凡例通りに並べるために取得順も考慮している
   */
  public async setCalendarEvents(): Promise<void | SystemError> {
    try {
      this.calendarIsBusy = true;

      let id: number = 1;
      let events: Array<CalendarEvent> = [];

      const permitted: PermittedFunctions = userStore.facility.permittedFunctions;

      // 各データを並列で取得する
      const [residents, inspectionReservations, facilityEvents, reservations, outings, onlineMeetings, facilityCalendarEvents] = await Promise.all([
        this.getResidents(),
        this._useWaiterService ? this.getInspectionReservations() : Promise.resolve([]),
        this.getFacilityEvents(),
        permitted.reservation == true || permitted.onlineReservation == true ? this.getReservations() : Promise.resolve([]),
        this._isOverLightPlan && permitted.outing == true ? this.getOutings() : Promise.resolve([]),
        this._useOtherOfficeService ? this.getOnlineMeetings() : Promise.resolve([]),
        this.getCalendarEvents()
      ]);

      // 利用者
      const residentEvents: Array<CalendarEvent> = this.createResidentEvents(residents, id);
      events = events.concat(residentEvents);
      id += residentEvents.length;

      // 施設見学
      if (this._useWaiterService) {
        const reservationInspectionEvents: Array<CalendarEvent> = this.createInspectionReservationEvents(inspectionReservations, id);
        events = events.concat(reservationInspectionEvents);
        id += reservationInspectionEvents.length;
      }

      // イベント
      const eventEvents: Array<CalendarEvent> = this.createEventEvents(facilityEvents, id);
      events = events.concat(eventEvents);
      id += eventEvents.length;

      // 面会予約
      if (permitted.reservation == true || permitted.onlineReservation == true) {
        const reservationEvents: Array<CalendarEvent> = this.createReservationEvents(reservations, id);
        events = events.concat(reservationEvents);
        id += reservationEvents.length;
      }

      // 外出外泊届け
      if (this._isOverLightPlan && permitted.outing == true) {
        const outingEvents: Array<CalendarEvent> = this.createOutingEvents(outings, id);
        events = events.concat(outingEvents);
        id += outingEvents.length;
      }

      // オンライン会議
      if (this._useOtherOfficeService) {
        const onlineMeetingEvents: Array<CalendarEvent> = this.createOnlineMeetingEvents(onlineMeetings, id);
        events = events.concat(onlineMeetingEvents);
        id += onlineMeetingEvents.length;
      }

      // オリジナルイベント
      const calendarEvents: Array<CalendarEvent> = this.createCalendarEvents(facilityCalendarEvents, id);
      events = events.concat(calendarEvents);
      id += calendarEvents.length;

      const sortedEvents: Array<CalendarEvent> = this.sortCalendarEvent(events);

      this.events = sortedEvents;
      this.calendarIsBusy = false;
    } catch (error) {
      // Promise.all()で並列に実行されるので例外を投げなおすのではなく例外を戻り値として返す
      return error as SystemError;
    }

    return;
  }

  /**
   * ### カレンダーイベントを昇順ソートする
   */
  public sortCalendarEvent(events: Array<CalendarEvent>): Array<CalendarEvent> {
    return events.concat().sort((a, b) => {
      const aStartDate: number = this.$dateUtil.convertDateToNumber(new Date(a.start.dateTime as string), "yyyymmddhhMMss");
      const bStartDate: number = this.$dateUtil.convertDateToNumber(new Date(b.start.dateTime as string), "yyyymmddhhMMss");

      if (aStartDate > bStartDate) {
        return 1;
      }
      if (aStartDate < bStartDate) {
        return -1;
      }
      return 0;
    });
  }

  /**
   * ### カレンダーイベントを取得する
   */
  public async getCalendarEvents(): Promise<Array<CalendarEventGetModel>> {
    const response: Array<CalendarEventGetModel> = await this.calendarEventsService.gets(userStore);
    return response;
  }

  /**
   * ### カレンダー表示用のイベントを作成する
   */
  public createCalendarEvents(calendarEvents: Array<CalendarEventGetModel>, id: number): Array<CalendarEvent> {
    let events: Array<CalendarEvent> = [];

    for (const calendarEvent of calendarEvents) {
      const momentFormatStartDate: Date = this.$dateUtil.convertNumberToDate(calendarEvent.startDatetime);
      const startDate: Moment = moment(momentFormatStartDate);
      const momentFormatEndDate: Date = this.$dateUtil.convertNumberToDate(calendarEvent.endDatetime);
      const endDate: Moment = moment(momentFormatEndDate);

      const event: CalendarEvent = {
        id: id,
        summary: `${calendarEvent.title}`,
        description: calendarEvent.text ? calendarEvent.text : "",
        start: {
          date: startDate.format("YYYY-MM-DD"),
          dateTime: startDate.toISOString()
        },
        end: {
          date: endDate.format("YYYY-MM-DD"),
          dateTime: endDate.toISOString()
        },
        hitomeQEvent: {
          color: calendarEvent.color.font,
          bgColor: calendarEvent.color.background,
          borderColor: calendarEvent.color.border,
          type: CalendarHitomeQEventType.MEMO,
          source: calendarEvent
        }
      };
      id++;
      events.push(event);
    }

    return events;
  }

  /**
   * ### カレンダー表示用のイベントを作成する
   */
  public createResidentEvents(residents: Array<ResidentGetModel>, id: number): Array<CalendarEvent> {
    let events: Array<CalendarEvent> = [];

    for (const resident of residents) {
      // v3.29.0からv3.30.0にアップデートしたタイミングでキャッシュクリアしていない施設でinAndOutDatetimesがundefinedになる可能性がある
      // undefinedの場合はスキップする
      if (!resident.inAndOutDatetimes) {
        continue;
      }
      for (const inAndOutDatetime of resident.inAndOutDatetimes) {
        if (inAndOutDatetime.inDatetime) {
          const momentFormatStartDate: Date = this.$dateUtil.convertNumberToDate(inAndOutDatetime.inDatetime);
          const startDate: Moment = moment(momentFormatStartDate);
          const endDate: Moment = startDate.clone();
          endDate.add(1, "hour");

          const event: CalendarEvent = {
            id: id,
            summary: `${resident.name}`,
            start: {
              date: startDate.format("YYYY-MM-DD"),
              dateTime: startDate.toISOString()
            },
            end: {
              date: endDate.format("YYYY-MM-DD"),
              dateTime: endDate.toISOString()
            },
            hitomeQEvent: {
              color: this.eventColors.resident.color,
              bgColor: this.eventColors.resident.bgColor,
              type: CalendarHitomeQEventType.RESIDENT_IN_DATE,
              source: resident
            }
          };
          id++;
          events.push(event);
        }
        if (inAndOutDatetime.outDatetime) {
          const momentFormatStartDate: Date = this.$dateUtil.convertNumberToDate(inAndOutDatetime.outDatetime);
          const startDate: Moment = moment(momentFormatStartDate);
          const endDate: Moment = startDate.clone();
          endDate.add(1, "hour");

          const event: CalendarEvent = {
            id: id,
            summary: `${resident.name}`,
            start: {
              date: startDate.format("YYYY-MM-DD"),
              dateTime: startDate.toISOString()
            },
            end: {
              date: endDate.format("YYYY-MM-DD"),
              dateTime: endDate.toISOString()
            },
            hitomeQEvent: {
              color: this.eventColors.resident.color,
              bgColor: this.eventColors.resident.bgColor,
              type: CalendarHitomeQEventType.RESIDENT_OUT_DATE,
              source: resident
            }
          };
          id++;
          events.push(event);
        }
      }
    }

    return events;
  }

  /**
   * ### イベントを取得する
   */
  public async getFacilityEvents(): Promise<Array<EventGetModel>> {
    let params: any = {
      needFiltering: "true"
    };
    const response: Array<EventGetModel> = await this.eventsService.gets(userStore, params);
    return response;
  }

  /**
   * ### カレンダー表示用のイベントを作成する
   */
  public createEventEvents(facilityEvents: Array<EventGetModel>, id: number): Array<CalendarEvent> {
    let events: Array<CalendarEvent> = [];

    for (const facilityEvent of facilityEvents) {
      const momentFormatStartDate: Date = this.$dateUtil.convertNumberToDate(facilityEvent.timeFrom);
      const momentFormatEndDate: Date = this.$dateUtil.convertNumberToDate(facilityEvent.timeTo);
      const startDate: Moment = moment(momentFormatStartDate);
      const endDate: Moment = moment(momentFormatEndDate);

      let type: CalendarHitomeQEventType = CalendarHitomeQEventType.UNKNOWN;
      switch (facilityEvent.holdType) {
        case EventHoldType.LOCAL_ONLY: {
          type = CalendarHitomeQEventType.EVENT_LOCAL_ONLY;
          break;
        }
        case EventHoldType.ONLINE_ONLY: {
          type = CalendarHitomeQEventType.EVENT_ONLINE_ONLY;
          break;
        }
        case EventHoldType.LOCAL_AND_ONLINE: {
          type = CalendarHitomeQEventType.EVENT_LOCAL_AND_ONLINE;
          break;
        }
        default: {
          type = CalendarHitomeQEventType.UNKNOWN;
          break;
        }
      }

      const event: CalendarEvent = {
        id: id,
        summary: `${facilityEvent.title}`,
        start: {
          date: startDate.format("YYYY-MM-DD"),
          dateTime: startDate.toISOString()
        },
        end: {
          date: endDate.format("YYYY-MM-DD"),
          dateTime: endDate.toISOString()
        },
        hitomeQEvent: {
          color: this.eventColors.event.color,
          bgColor: this.eventColors.event.bgColor,
          type: type,
          source: facilityEvent
        }
      };
      id++;
      events.push(event);
    }

    return events;
  }

  /**
   * ### 面会予約を取得する
   */
  public async getReservations(): Promise<Array<ReservationsGetModel>> {
    // 開始日時を指定する
    let currentDate: Moment = this.currentDate.clone();
    const start: number = this.$dateUtil.convertDateToNumber(currentDate.toDate(), "yyyymmdd000000000");
    currentDate.add(6, "days");
    const end: number = this.$dateUtil.convertDateToNumber(currentDate.toDate(), "yyyymmdd235900000");
    let params: any = {
      start: start,
      end: end
    };

    const response: Array<ReservationsGetModel> = await this.reservationsService.gets(userStore, params);

    return response;
  }

  /**
   * ### カレンダー表示用のイベントを作成する
   */
  public createReservationEvents(reservations: Array<ReservationsGetModel>, id: number): Array<CalendarEvent> {
    let events: Array<CalendarEvent> = [];

    for (const reservation of reservations) {
      const momentFormatStartDate: Date = this.$dateUtil.convertNumberToDate(reservation.datetime as number);
      const startDate: Moment = moment(momentFormatStartDate);
      const endDate: Moment = startDate.clone();
      endDate.add(1, "hour");

      const event: CalendarEvent = {
        id: id,
        summary: `${reservation.residentName}`,
        start: {
          date: startDate.format("YYYY-MM-DD"),
          dateTime: startDate.toISOString()
        },
        end: {
          date: endDate.format("YYYY-MM-DD"),
          dateTime: endDate.toISOString()
        },
        hitomeQEvent: {
          color: this.eventColors.reservation.color,
          bgColor: this.eventColors.reservation.bgColor,
          type: reservation.type == ReservationType.ONLINE ? CalendarHitomeQEventType.RESERVATION_ONLINE : CalendarHitomeQEventType.RESERVATION_VISIT,
          source: reservation
        }
      };
      id++;
      events.push(event);
    }

    return events;
  }

  /**
   * ### 外出外泊届けを取得する
   */
  public async getOutings(): Promise<Array<OutingGetModel>> {
    // 範囲日時を指定する
    let currentDate: Moment = this.currentDate.clone();
    const start: number = this.$dateUtil.convertDateToNumber(currentDate.toDate(), "yyyymm01000000000");
    currentDate.add(6, "days");
    const end: number = this.$dateUtil.convertDateToNumber(currentDate.toDate(), "yyyymmdd235900000");
    let params: any = {
      start: start,
      end: end
    };
    const response: Array<OutingGetModel> = await this.outingsService.gets(userStore, params);
    return response;
  }

  /**
   * ### カレンダー表示用の外出外泊届けイベントを作成する
   */
  public createOutingEvents(outings: Array<OutingGetModel>, id: number): Array<CalendarEvent> {
    let events: Array<CalendarEvent> = [];

    for (const outing of outings) {
      // 削除済みも取得されるので、削除済みはスキップする
      if (outing.deleteFlag) {
        continue;
      }

      const momentFormatStartDate: Date = this.$dateUtil.convertNumberToDate(outing.startDatetime as number);
      const startDate: Moment = moment(momentFormatStartDate);
      const momentFormatSEndDate: Date = this.$dateUtil.convertNumberToDate(outing.endDatetime as number);
      const endDate: Moment = moment(momentFormatSEndDate);

      const event: CalendarEvent = {
        id: id,
        summary: `${outing.targetResidentInfo.name}`,
        start: {
          date: startDate.format("YYYY-MM-DD"),
          dateTime: startDate.toISOString()
        },
        end: {
          date: endDate.format("YYYY-MM-DD"),
          dateTime: endDate.toISOString()
        },
        hitomeQEvent: {
          color: this.eventColors.outing.color,
          bgColor: this.eventColors.outing.bgColor,
          borderColor: this.eventColors.outing.borderColor ? this.eventColors.outing.borderColor : undefined,
          type: outing.type == OutingType.GOING_OUT ? CalendarHitomeQEventType.OUTING_GOING_OUT : CalendarHitomeQEventType.OUTING_STAYING_OUT,
          source: outing
        }
      };
      id++;
      events.push(event);
    }

    return events;
  }

  /**
   * ### 施設見学予約を取得する
   */
  public async getInspectionReservations(): Promise<Array<InspectionReservationsGetModel>> {
    // 範囲日時を指定する
    let currentDate: Moment = this.currentDate.clone();
    const start: number = this.$dateUtil.convertDateToNumber(currentDate.toDate(), "yyyymm01000000000");
    currentDate.add(6, "days");
    const end: number = this.$dateUtil.convertDateToNumber(currentDate.toDate(), "yyyymmdd235900000");
    let params: any = {
      start: start,
      end: end
    };
    const response: Array<InspectionReservationsGetModel> = await this.inspectionReservationsService.gets(userStore, params);
    return response;
  }

  /**
   * ### カレンダー表示用の施設見学予約イベントを作成する
   */
  public createInspectionReservationEvents(inspectionReservations: Array<InspectionReservationsGetModel>, id: number): Array<CalendarEvent> {
    let events: Array<CalendarEvent> = [];

    for (const reservation of inspectionReservations) {
      if (reservation.approved == false || !reservation.datetime) {
        continue;
      }

      const momentFormatStartDate: Date = this.$dateUtil.convertNumberToDate(reservation.datetime as number);
      const startDate: Moment = moment(momentFormatStartDate);
      const endDate: Moment = startDate.clone();
      endDate.add(1, "hour");

      const event: CalendarEvent = {
        id: id,
        summary: `${reservation.name}`,
        start: {
          date: startDate.format("YYYY-MM-DD"),
          dateTime: startDate.toISOString()
        },
        end: {
          date: endDate.format("YYYY-MM-DD"),
          dateTime: endDate.toISOString()
        },
        hitomeQEvent: {
          color: this.eventColors.inspectionReservation.color,
          bgColor: this.eventColors.inspectionReservation.bgColor,
          type: CalendarHitomeQEventType.INSPECTION_RESERVATION,
          source: reservation
        }
      };
      id++;
      events.push(event);
    }

    return events;
  }

  /**
   * ### オンライン会議を取得する
   */
  public async getOnlineMeetings(): Promise<Array<OtherOfficeOnlineMeetingGetModel>> {
    const currentDate: Moment = this.currentDate.clone();
    const start: number = this.$dateUtil.convertDateToNumber(currentDate.toDate(), "yyyymm01000000000");
    currentDate.add(6, "days");
    const end: number = this.$dateUtil.convertDateToNumber(currentDate.toDate(), "yyyymmdd235900000");
    let params: any = {
      start: start,
      end: end
    };
    const response: Array<OtherOfficeOnlineMeetingGetModel> = await this.meetingsService.gets(userStore, params);
    return response;
  }

  /**
   * ### カレンダー表示用のオンライン会議イベントを作成する
   */
  public createOnlineMeetingEvents(onlineMeetings: Array<OtherOfficeOnlineMeetingGetModel>, id: number): Array<CalendarEvent> {
    let events: Array<CalendarEvent> = [];

    for (const onlineMeeting of onlineMeetings) {
      const momentFormatStartDate: Date = this.$dateUtil.convertNumberToDate(onlineMeeting.startDatetime as number);
      const startDate: Moment = moment(momentFormatStartDate);
      const momentFormatEndDate: Date = this.$dateUtil.convertNumberToDate(onlineMeeting.endDatetime as number);
      const endDate: Moment = moment(momentFormatEndDate);

      const event: CalendarEvent = {
        id: id,
        summary: `${onlineMeeting.title}`,
        start: {
          date: startDate.format("YYYY-MM-DD"),
          dateTime: startDate.toISOString()
        },
        end: {
          date: endDate.format("YYYY-MM-DD"),
          dateTime: endDate.toISOString()
        },
        hitomeQEvent: {
          color: this.eventColors.onlineMeeting.color,
          bgColor: this.eventColors.onlineMeeting.bgColor,
          borderColor: this.eventColors.onlineMeeting.borderColor ? this.eventColors.onlineMeeting.borderColor : undefined,
          type: CalendarHitomeQEventType.ONLINE_MEETING,
          source: onlineMeeting
        }
      };
      id++;
      events.push(event);
    }

    return events;
  }

  public gotoReport(): void {
    this.$router.push(PcUrl.Report);
    return;
  }

  get _enableReportsByPlan(): boolean {
    const planType: PlanType = userStore.facility.planType;
    if (PlanType.LIGHT <= planType) {
      return true;
    } else {
      return false;
    }
  }

  get _enableReportsByPermittedFunction(): boolean {
    return userStore.loginUser.permissions.functions.reportsFunction;
  }
}

interface CalendarFunctionEvent {
  original: CalendarEventColor;
  resident: CalendarEventColor;
  event: CalendarEventColor;
  reservation: CalendarEventColor;
  inspectionReservation: CalendarEventColor;
  onlineMeeting: CalendarEventColor;
  outing: CalendarEventColor;
}

interface CalendarEventColor {
  color: string;
  bgColor: string;
  borderColor?: string;
}
</script>

<style lang="scss" scoped>
@import "../../styles/pc/_mixin.scss";
@import "../../styles/pc/_colors.scss";

#home-for-families-service {
  .facility-base-info {
    margin-left: -3px;
    margin-right: -3px;
    .home-box {
      padding-left: 3px;
      padding-right: 3px;
    }
  }
  .box {
    .title {
      @include bold-font();
      padding: 10px 0 0 10px;
    }
    .use-hour-graph-date {
      @include bold-font();
      text-align: center;
    }
    .goto-reports-btn {
      font-size: 12px !important;
      height: 24px !important;
      margin-right: 10px !important;
    }
    .goto-reports-btn.disable {
      cursor: not-allowed;
    }
  }

  .calendar {
    .open-all,
    .close-all {
      font-size: 14px;
      color: $font-key-color;
      font-weight: normal;
      text-decoration: underline;
      cursor: pointer;
    }

    .box-body {
      overflow-y: auto;
      overflow-x: auto;
    }
    .options {
      .filter {
        min-width: 240px;
        max-width: 320px;
      }
    }
  }

  .graphs {
    .box-body {
      position: relative;
      height: 278px;
    }
    .ratio-graph {
      @media (min-width: 992px) {
        padding-right: 3px !important;
        margin-bottom: 0 !important;
      }
      @media (max-width: 992px) {
        padding-right: 15px !important;
        margin-bottom: 16px !important;
      }
    }
    .bar-graph {
      @media (min-width: 992px) {
        padding-left: 3px !important;
        margin-bottom: 0 !important;
      }
      .date {
        @include font(20px);
        margin: 0 20px;
      }
      .change-date-btn {
        min-width: 104px;
      }
    }
  }
}
</style>
